import React from "react";
import styles from './DocumentProcessor.module.css';

export default function TabsSwitcher({ config, activeTab, setActiveTab }) {
    return (
        <div className={styles.subTabHeader}>
            {Object.keys(config).map((key) => (
                <div
                    key={key}
                    className={`${styles.subTabItem} ${activeTab === key ? styles.activeSubTab : ""
                        }`}
                    onClick={() => setActiveTab(key)}
                >
                    {config[key].tabName}
                </div>
            ))}
        </div>
    );
}
